import * as React from 'react';
import { JSX } from 'react/jsx-runtime';
const AccordianUpIconDark = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 6.5L6 1.5L1 6.5"
      stroke="#EEF7FF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default AccordianUpIconDark;
